<template>
    <section class="fullscreen fullscreen--middle">
        <div class="w--100 text--center">
            <div class="container intro-content pt--40 pb--40">
                <img src="/img/logo.png" alt="" class="intro-content__logo logo-loading mb--30" />

                <h3 class="dot-loading mb--0"><slot></slot></h3>
                <h4 class="opacity--sm"><slot name="subtitle"></slot></h4>
                <slot name="content"></slot>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
    }
</script>